// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"4367e49f","453":"7bd20ed8","454":"6d303744"}[chunkId] + ".chunk.js";
};